import type { OfficeLocationLink } from '@jlg-website/database/types';
import type { DesktopMenu, DropdownMenu, SubmenuItem } from './type';
import { groupLocationsByCountry } from './location-groups';

export const PRACTICE_AREAS_IMAGE = '/images/nh-submenu.webp';
export const OFFICES_IMAGE = '/images/offices-menu.png';

/** Minimal structural shape the builder needs — decoupled from the full DB type. */
type ClaimSectionInput = {
  name?: string;
  visible?: boolean;
  pages?: { slug: string; published_at: Date | null }[];
};

export function buildClaimSubmenu(claimSections: ClaimSectionInput[]): SubmenuItem[] {
  return claimSections
    .filter((section) => section.visible)
    .filter((section) => !!section.pages?.length && section.pages.some((p) => p.published_at))
    .map((section) => ({
      label: section.name,
      url: section.pages?.[0]?.slug ?? '#',
    }));
}

/**
 * Single source of truth mapping domain data (claim sections, offices) to the
 * generic {@link DropdownMenu} content each navbar dropdown renders.
 */
export function buildDropdownMenus(
  claimSections: ClaimSectionInput[],
  locations: OfficeLocationLink[]
): Record<DesktopMenu, DropdownMenu> {
  return {
    claim: {
      sections: [{ items: buildClaimSubmenu(claimSections) }],
      image: PRACTICE_AREAS_IMAGE,
      footer: { label: 'See all practice areas', href: '/practice-areas' },
    },
    locations: {
      sections: groupLocationsByCountry(locations),
      image: OFFICES_IMAGE,
    },
  };
}
